// The audit log — mirrors packages/server/src/routes/audit.ts.

import { apiFetch } from './api';

export interface AuditEvent {
  id: string;
  createdAt: number;
  action: string;
  actorAgentId: string | null;
  /** "Name <email>" at the time, kept after the agent is deleted. */
  actorLabel: string;
  siteId: string | null;
  siteName: string | null;
  targetType: string | null;
  targetId: string | null;
  summary: string;
  details: Record<string, unknown>;
  ip: string | null;
}

export interface AuditPage {
  events: AuditEvent[];
  nextCursor: string | null;
  /** Every action the log can hold, for the filter. */
  actions: string[];
}

export async function fetchAuditLog(params: { siteId?: string; action?: string; cursor?: string }): Promise<AuditPage> {
  const qs = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) if (v) qs.set(k, v);
  return apiFetch<AuditPage>(`/api/admin/audit${qs.size ? `?${qs}` : ''}`);
}
